import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import {DeleteItemsApi} from '../../../../../reduxToolkit/Commons/CommonsApi';
import {useParamsContextProvider} from '../../../../../hooks/ParamsContextProvider';
import {errorMsg} from "../../../../../Apis/functions";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const CommonFoodieMainApp = ({setIsAllChecked,  tabIndex, tableName, selectedList, setSelectedList, setModified}) => {
    const dispatch = useDispatch();
    const { paramsContext, setParamsContext } = useParamsContextProvider();
    const [deleteModalShow, setDeleteModalShow] = useState(false);

    /**
     * useEffect to open the delete modal based on the modalDelete variable from the context and selectedList
     */
    useEffect(() => {
        if(paramsContext && paramsContext?.tabIndex === tabIndex && selectedList?.length > 0)
            setDeleteModalShow(paramsContext.modalDelete)
    }, [paramsContext]);

    /**
     * Clears the list of items to delete
     */
    useEffect(() => {
        if(!deleteModalShow)
            setSelectedList([])
    }, [deleteModalShow]);

    /**
     * Disable the delete button from the context and/or globally
     */
    useEffect(() => {
        if(paramsContext && paramsContext?.tabIndex === tabIndex){
            setParamsContext(prev => ({
                ...prev,
                disabledBtnDelete: selectedList?.length <= 0
            }));
        }
    }, [selectedList]);

    /**
     * Function that calls the global API to delete a list of elements
     */
    const handleDeleteSelected = () => {
        if (selectedList.length > 0) {
            dispatch(DeleteItemsApi({ tableName: tableName , body: selectedList })).then(({payload: {data: { data, success, code }}}) => {
                if (success === true) {
                    setModified(true);
                    setSelectedList([]);
                    setIsAllChecked(false);
                    handleDeleteModalClose();
                }else errorMsg(code);
            });
        }
    };

    /**
     * Function that open modal to delete a element
     */
    const handleDeleteItem = (item) => {
        setParamsContext(prev => ({
            ...prev,
            modalDelete: true
        }));
        setSelectedList([item.id])
    };

    /**
     * Function to hide the delete modal
     */
    const handleDeleteModalClose = () => {
        if(setParamsContext){
            setParamsContext(prev => ({
                ...prev,
                modalDelete: false
            }));
        }
    }

    return {
        deleteModalShow,
        handleDeleteSelected,
        handleDeleteModalClose,
        handleDeleteItem
    }
}

export default CommonFoodieMainApp;
